module.exports = __webpack_public_path__ + "static/media/list.fab7d6a8.svg";